import {delayFor} from '/util/timer.util';

export const handlePinModalScreen = ({
  getUserPinValue,
  getPinOptInValue,
  setPinCodeHash,
  setPinSetup,
}: any) => {
  getUserPinValue().then((val: any) => setPinCodeHash(val));
  getPinOptInValue().then((val: any) => {
    setPinSetup(val);
  });
};
export const handleSuccessScreenFallback = ({showSuccess, onClose}: any) => {
  showSuccess && delayFor(6000).then(() => onClose());
};
